export const STAGES = ["Nuevo", "Contactado", "Interesado", "Cita agendada", "Cita realizada", "Venta realizada", "Perdido"];

export const CHANNELS = ["Página web", "WhatsApp", "Instagram", "Facebook", "Correo", "SMS", "Teléfono", "Referido", "Presencial"];

export const MESSAGE_CHANNELS = ["WhatsApp", "Instagram", "Facebook", "Correo", "SMS"];

export const CONV_STATUS_STYLES = {
  Nueva: "bg-sky-50 text-sky-700 border-sky-200",
  Pendiente: "bg-amber-50 text-amber-700 border-amber-200",
  Respondida: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const REFERRAL_SOURCES = ["Google", "Instagram", "Facebook", "TikTok", "Recomendación", "Publicidad", "Otro"];

export const ROLE_LABELS = { admin: "Administrador", supervisor: "Supervisor", vendedor: "Vendedor" };

export const STAGE_STYLES = {
  Nuevo: "bg-sky-50 text-sky-700 border-sky-200",
  Contactado: "bg-blue-50 text-blue-700 border-blue-200",
  Interesado: "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Cita agendada": "bg-amber-50 text-amber-700 border-amber-200",
  "Cita realizada": "bg-teal-50 text-teal-700 border-teal-200",
  "Venta realizada": "bg-emerald-50 text-emerald-700 border-emerald-200",
  Perdido: "bg-rose-50 text-rose-700 border-rose-200",
};

export const CHANNEL_STYLES = {
  "Página web": "bg-slate-50 text-slate-700 border-slate-200",
  Web: "bg-sky-50 text-sky-700 border-sky-200",
  WhatsApp: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Instagram: "bg-pink-50 text-pink-700 border-pink-200",
  Facebook: "bg-blue-50 text-blue-700 border-blue-200",
  Correo: "bg-cyan-50 text-cyan-700 border-cyan-200",
  SMS: "bg-orange-50 text-orange-700 border-orange-200",
  Teléfono: "bg-violet-50 text-violet-700 border-violet-200",
  Referido: "bg-amber-50 text-amber-700 border-amber-200",
  Presencial: "bg-teal-50 text-teal-700 border-teal-200",
};

export const SERVICE_ICONS = ["ScanLine", "FlaskConical", "Stethoscope", "HeartPulse", "Microscope", "Brain", "Activity", "Baby", "Eye", "Bone"];

export const waLink = (num, text = "Hola, quisiera información sobre Centro Médico IEMED.") =>
  `https://wa.me/${String(num || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export const telLink = (phone) => `tel:${String(phone || "").replace(/[^\d+]/g, "")}`;

export const mapsLink = (q) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q || "")}`;

export const mapsEmbed = (q) => `https://www.google.com/maps?q=${encodeURIComponent(q || "")}&output=embed`;

export const slugify = (s) =>
  String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
